const defaultConfig = {
	componentName: 'fuse-loading-spinner',
	colours: {
		primary: 'var(--color-brand-mid)',
		secondary: 'var(--color-global-black)',
		tertiary: 'var(--color-base-white)',
	},
};

export default defaultConfig;
